import { FolderContent } from '@/api/generatedApi';
import { StyledListItem } from '@/components/AssetsPage/PopoverList';
import { useTenants } from '@/services/tenants/useTenants';
import { isFolder } from '@/utils/folders';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ListItemIcon, ListItemText } from '@mui/material';

export const OpenInNewTabMenuItem = ({ item, onClose }: { item: FolderContent; onClose: () => void }) => {
  const { getPath } = useTenants();

  const handleClick = () => {
    const url = isFolder(item) ? getPath(`assets?folderId=${item.id}`) : getPath(`asset/${item.id}`);
    window.open(url, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <StyledListItem onClick={handleClick}>
      <ListItemIcon>
        <OpenInNewIcon sx={{ fontSize: '18px' }} />
      </ListItemIcon>
      <ListItemText>Open in New Tab</ListItemText>
    </StyledListItem>
  );
};
